function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.7208 15.8325H13.2621H12.3307H12.1296V11.1932H13.6468C14.0316 11.1932 14.259 10.7559 14.0316 10.4411L11.0801 6.35711C10.8921 6.09475 10.503 6.09475 10.3149 6.35711L7.36344 10.4411C7.13606 10.7559 7.35907 11.1932 7.74823 11.1932H9.26552V15.8325H9.06438H8.13301H4.12335C1.82774 15.7057 0 13.5588 0 11.2325C0 9.6278 0.870145 8.22858 2.16006 7.47212C2.042 7.15292 1.98078 6.81186 1.98078 6.4533C1.98078 4.81358 3.30568 3.48869 4.9454 3.48869C5.29958 3.48869 5.64064 3.54991 5.95984 3.66797C6.90869 1.65657 8.95506 0.261719 11.3337 0.261719C14.4121 0.266091 16.9482 2.62292 17.2367 5.62689C19.6023 6.03354 21.3994 8.2242 21.3994 10.7035C21.3994 13.3533 19.3356 15.6489 16.7208 15.8325Z",
  fill: "#939AA3"
});

function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.765e1d17.svg";
export { ForwardRef as ReactComponent };